import { render } from "./ChangeLogElement.vue?vue&type=template&id=0c0e0ee8&scoped=true&ts=true"
import script from "./ChangeLogElement.vue?vue&type=script&lang=ts"
export * from "./ChangeLogElement.vue?vue&type=script&lang=ts"

import "./ChangeLogElement.vue?vue&type=style&index=0&id=0c0e0ee8&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0e0ee8"]])

export default __exports__